export const TOAST_EVENTS_TYPE = {
  closedToast: 'CLOSED_TOAST',
  showToast: 'SHOW_TOAST',
} as const
